module.exports = __webpack_public_path__ + "static/rangeSelection-13773aa357c720d6d7e44de6114ebdaa.gif";